var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddOns1 = function SvgAddOns1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 23,
    fill: "none",
    viewBox: "0 0 25 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6CFF",
    fillRule: "evenodd",
    d: "M7.344 5.42a3.42 3.42 0 1 1 6.839.054h1.94a2.4 2.4 0 0 1 2.401 2.403v1.94h.056a3.42 3.42 0 1 1-.056 6.84v1.94A2.4 2.4 0 0 1 16.122 21H5.402A2.4 2.4 0 0 1 3 18.598v-2.903a.814.814 0 0 1 1.086-.768q.279.1.597.102a1.791 1.791 0 1 0-.597-3.481A.814.814 0 0 1 3 10.78V7.877a2.4 2.4 0 0 1 2.402-2.403h1.942zm3.42-1.791a1.79 1.79 0 0 0-1.69 2.388.814.814 0 0 1-.768 1.086H5.402a.774.774 0 0 0-.774.774v1.94h.055a3.42 3.42 0 1 1-.055 6.84v1.94c0 .428.347.774.774.774h10.72a.774.774 0 0 0 .774-.773v-2.904a.814.814 0 0 1 1.086-.767q.28.1.598.102a1.791 1.791 0 1 0-.598-3.481.814.814 0 0 1-1.086-.768V7.877a.774.774 0 0 0-.774-.774h-2.901a.814.814 0 0 1-.768-1.086q.1-.28.102-.597c0-.99-.802-1.791-1.791-1.791",
    clipRule: "evenodd"
  })));
};
export default SvgAddOns1;